// Accepts both `{ id: item }` and the legacy `{ id: [item] }` response shapes
export function flattenMap(map: Record<string, any> | null | undefined) {
	const result: Record<string, any> = {};
	Object.keys(map || {}).forEach((id) => {
		const value = Array.isArray(map?.[id]) ? map?.[id][0] : map?.[id];
		if (value) result[id] = value;
	});
	return result;
}
